import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <div className="footer">
            <p>&copy; 2024 JoshMachPharmacy</p>
        </div>
    );
};

export default Footer;
